// const BaseURL = process.env.NODE_ENV == 'development' ? 'http://192.84.100.138:3000/dev' : 'http://localhost:8000'
// let baseLocal = 'http://192.84.100.138:3000/dev'
// let baseDev = 'https://68ewwhmt45.execute-api.ap-northeast-1.amazonaws.com/dev'
// let baseStaging = 'https://3kkilgzcf0.execute-api.ap-northeast-1.amazonaws.com/sun-cms-staging'

// const BaseURL = process.env.VUE_APP_NOTE == "LOCAL" ? baseLocal : process.env.VUE_APP_NOTE == "DEV" ? baseDev : baseStaging

import { BaseURL } from "@/utils/config";

// const BaseURL = baseDev
const api = {
  BaseURL,
  Season: "/season/",
  Chapter: "/chapter/",
  Section: "/section/",
  Question: "/question/",
  Grammar: "/grammar/",
  Example: "_example",
  Conversation: "/conversation/",
  Badge: "/badge/",
  Tab: "/tab/",
  Category: "/category/",
  Vocabulary: "/vocabulary/",
  DatetimeVocabulary: "/datetimevocabulary/",
  Pratice: "/pratice/",
  Actor: "_actor",
  Expression: "/expression/",
  Menu: "/resource/menu/",
  Icon: "/resource/",
  MasterData: "/master_data/",
  Mobile: "/mobile/auth/"
};
export default api;
